import {
    Alert,
} from '@acp/core-ui';
import { Text } from '@chakra-ui/react';
import { faLink } from '@fortawesome/pro-solid-svg-icons';

export function IntegratedPropertyDialog({
    title,
}: {
    title: string;
}) {
    return (
        <Alert
            status="info"
            title={title}
            icon={faLink}
        >
            <Text>
                To make changes, update your software directly.
                Changes may take up to 24 hours to appear.
            </Text>
        </Alert>
    );
}
